const initialState = {
	reviewsModalOpen: false
};

const reviewsReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'toggle-reviews-modal':
			return {
				...state,
				reviewsModalOpen: action.payload
			};
		default:
			return state;
	}
};

export default reviewsReducer;
